import { logStartUsage } from './logStartUsage';
import {
    type CustomDataMap,
    type DatapointOptions,
    DatapointStatus,
    type TraceErrorObject,
    type INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT,
} from 'owa-analytics-types';
import type { AnalyticsEventNames, AnalyticsCoreEventNames } from 'owa-analytics-events';
import type { MailboxInfo } from 'owa-client-types';

export class LogStartPerformanceUsage {
    private eventName: AnalyticsEventNames | AnalyticsCoreEventNames;
    private mailboxInfo:
        | MailboxInfo
        | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT
        | undefined;
    private customData: CustomDataMap = {};
    private hasEnded = false;
    private startTime: number;
    private options: DatapointOptions | undefined;

    constructor(
        eventName: AnalyticsEventNames | AnalyticsCoreEventNames,
        mailboxInfo?: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT,
        options?: DatapointOptions
    ) {
        this.eventName = eventName;
        this.mailboxInfo = mailboxInfo;
        this.options = options;
        this.startTime = Date.now();
    }

    addCheckpoint(name: string): void {
        this.customData[name] = Date.now() - this.startTime;
    }

    addCustomProperty(key: string, value: string | number | boolean | undefined | null): void {
        this.customData[key] = value;
    }

    end(): void {
        if (!this.hasEnded) {
            this.hasEnded = true;
            this.customData['Duration'] = Date.now() - this.startTime;
            this.customData['Status'] = DatapointStatus.Success;
            logStartUsage(this.eventName, this.mailboxInfo, this.customData, this.options);
        }
    }

    endWithError(status: DatapointStatus, error?: TraceErrorObject): void {
        if (!this.hasEnded) {
            this.hasEnded = true;
            this.customData['Duration'] = Date.now() - this.startTime;
            this.customData['Status'] = status;

            if (error) {
                this.customData['ErrorMessage'] = error.message;
                this.customData['ErrorDetails'] = error.stack;
                this.customData['AdditionalInfo'] = JSON.stringify(error.additionalInfo);
            }
            logStartUsage(this.eventName, this.mailboxInfo, this.customData, this.options);
        }
    }
}
